"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./localize/utils");

exports.accessoryPartDetails = {
  'sd80': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    'dimensions': '80 mm (Ø)',
    'part_type': 'SD80',
    'article': '2000056721',
    type: 'price'
  },
  'sd100': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    'dimensions': '80 mm (Ø)',
    'part_type': 'SD100',
    'article': '2000102696',
    type: 'price'
  },
  'sd99-010': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    'dimensions': '80 mm (Ø)',
    'part_type': 'SD99-010',
    'article': '2030039038',
    type: 'price'
  },
  'round_sleeve': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    dimensions: 'PartTranslation',
    'part_type': 'E-BS602E',
    'article': '2000101106',
    type: 'price'
  },
  'square_sleeve': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    dimensions: 'PartTranslation',
    'part_type': 'RODX607TT',
    'article': '2000101212',
    type: 'price'
  },
  'basket': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    dimensions: 'PartTranslation',
    'part_type': 'CHRX608',
    'article': '2000057138',
    type: 'price'
  },
  'rail_60': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    dimensions: 'PartTranslation',
    'part_type': 'ZANMW0042',
    'article': '2030053538',
    type: 'price'
  },
  'rail_150': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    dimensions: 'PartTranslation',
    'part_type': 'ZANMW0043',
    'article': '2030053539',
    type: 'price'
  },
  'rail_150_withcosmetic': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    dimensions: 'PartTranslation',
    'part_type': 'ZANMW0044',
    'article': '2030055226',
    type: 'price'
  },
  'flap': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    dimensions: 'PartTranslation',
    'part_type': 'RODX605TTH',
    'article': '2030064649',
    type: 'price'
  },
  'provider': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    dimensions: 'PartTranslation',
    'part_type': 'RODX600TT',
    'article': '2000102672',
    type: 'price'
  },
  'tissuedispenser': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    dimensions: 'PartTranslation',
    'part_type': 'ZANMW0045',
    'article': '2030007912',
    type: 'price'
  },
  'hood-chrome': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    'dimensions': '',
    'part_type': 'ZANMW0030',
    'article': '2030057337',
    type: 'price'
  },
  'hood': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    'dimensions': 'G 1 1/4 B',
    'part_type': 'ZANMW900',
    'article': '2000100861',
    type: 'price'
  },
  'sieve': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    'dimensions': 'G 1 1/4 B',
    'part_type': 'ZANMW901',
    'article': '2000100854',
    type: 'price'
  },
  'eccentric': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    'dimensions': 'G 1 1/4 B',
    'part_type': 'ZANMW902',
    'article': '2000100932',
    type: 'price'
  },
  'siphon': {
    name: 'PartTranslation',
    description: 'PartTranslation',
    'dimensions': '320mm - 360mm H',
    'part_type': 'XINX140',
    'article': '2000057417',
    type: 'price'
  }
};
exports.washbasinPartDetails = {
  'plate_depth_upto_530': {
    name: 'Base price 400 - 530 mm depth',
    description: 'Price valid up to 1000 mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'plate_depth_upto_560': {
    name: 'Base price 531 - 560 mm depth',
    description: 'Price valid up to 1000 mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'plate_depth_upto_600': {
    name: 'Base price 561 - 600 mm depth',
    description: 'Price valid up to 1000 mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'plate_depth_exos': {
    name: 'Base price EXOS. washbasins',
    description: 'Price valid up to 1000 mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'plate_depth_variusmed_mzb': {
    name: 'VARIUSmed MZB (incl. front and rear surge edge)',
    description: 'Price valid up to 1000mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'plate_depth_variusmed_rwt': {
    name: 'VARIUSmed RWT',
    description: 'Price valid up to 1000mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'plate_gelcoat': {
    name: 'Underside with Gelcoat (for all washbasins)',
    description: 'Price valid up to 1000mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'apron_front_upto_60': {
    name: 'Base price for apron height 60 mm',
    type: 'price'
  },
  'apron_front_upto_150': {
    name: 'Base price for apron height 61 - 150 mm',
    type: 'price'
  },
  'apron_side_upto_60': {
    name: 'Base price for apron height 60 mm',
    type: 'price'
  },
  'apron_side_upto_150': {
    name: 'Base price for apron height 61 - 150 mm',
    type: 'price'
  },
  'surgeedge_back': {
    name: 'At the back',
    type: 'price'
  },
  'surgeedge_lateral': {
    name: 'Lateral (each side)',
    type: 'price'
  },
  'backsplash_back': {
    name: 'Only at the back',
    type: 'price'
  },
  'backsplash_back_withlateral': {
    name: 'Rear (if at least 1x lateral)',
    type: 'price'
  },
  'backsplash_lateral': {
    name: 'Lateral (each side)',
    type: 'price'
  },
  'radius_without_apron': {
    name: 'Radius / bevel without apron (each side)',
    type: 'price'
  },
  'radius_with_apron': {
    name: 'Radius / bevel with apron up to 150 mm (each side)',
    type: 'price'
  },
  'radius_angleniche': {
    name: 'Bevel cut deviating 90º (with Gelcoat, each side)',
    type: 'price'
  },
  'cutout_tap': {
    name: 'Tap hole',
    type: 'price'
  },
  'cutout_soapdispenser': {
    name: 'Soap dispenser hole',
    type: 'price'
  },
  'cutout_towel_rail': {
    name: 'As towel rail (slotted hole) (contour straight)',
    type: 'price'
  },
  'cutout_waste_rail': {
    name: 'For waster rail system (square + round), incl. sockets in plate',
    type: 'price'
  },
  'cutout_disposal_sleeve': {
    name: 'For disposal sleeve (square + round)',
    type: 'price'
  },
  'cutout_individual': {
    name: 'Individual in plate (square + round)',
    type: 'price'
  },
  'cutout_disposal_flap': {
    name: 'For disposal flap',
    type: 'price'
  },
  'cutout_paper_towel': {
    name: 'For paper towel dispenser',
    type: 'price'
  },
  'cutout_cosmetic_tissue': {
    name: 'For cosmetic tissue dispenser in front apron (height 150 mm), incl. sockets in apron)',
    type: 'price'
  },
  'trough_eton': {
    name: 'ETON',
    type: 'price'
  },
  'trough_etonbp': {
    name: 'ETON BP',
    type: 'price'
  },
  'trough_pisa': {
    name: 'PISA',
    type: 'price'
  },
  'trough_milan': {
    name: 'MILAN',
    type: 'price'
  },
  'trough_berlin': {
    name: 'BERLIN',
    type: 'price'
  },
  'trough_paris': {
    name: 'PARIS',
    type: 'price'
  },
  'trough_lille': {
    name: 'LILLE',
    type: 'price'
  },
  'trough_nice': {
    name: 'NICE',
    type: 'price'
  },
  'trough_bern': {
    name: 'BERN',
    type: 'price'
  },
  'trough_graz': {
    name: 'GRAZ',
    type: 'price'
  },
  'trough_palma': {
    name: 'PALMA',
    type: 'price'
  },
  'trough_oslo': {
    name: 'OSLO',
    type: 'price'
  },
  'trough_oslobp': {
    name: 'OSLO BP',
    type: 'price'
  },
  'trough_oslopb': {
    name: 'OSLO PB',
    description: 'Should be the same as OSLO BP, this is a fix for SAP mispelling',
    type: 'price'
  },
  'trough_london': {
    name: 'LONDON',
    type: 'price'
  },
  'trough_bilbao': {
    name: 'BILBAO',
    type: 'price'
  },
  'trough_rome': {
    name: 'ROME',
    type: 'price'
  },
  'trough_romebp': {
    name: 'ROME BP',
    type: 'price'
  },
  'trough_como': {
    name: 'COMO',
    type: 'price'
  },
  'trough_munich': {
    name: 'MUNICH',
    type: 'price'
  },
  'trough_linz': {
    name: 'LINZ',
    type: 'price'
  },
  'trough_zurich': {
    name: 'ZURICH',
    type: 'price'
  },
  'trough_variusmed-rwt': {
    name: 'VARIUSmed RWT',
    type: 'price'
  },
  'trough_variusmed-mzb': {
    name: 'VARIUSmed MZB',
    type: 'price'
  },
  'trough_exos380': {
    name: 'EXOS. 380',
    type: 'price'
  },
  'trough_exos380bf': {
    name: 'EXOS. 380 BF',
    type: 'price'
  },
  'trough_exos500': {
    name: 'EXOS. 500',
    type: 'price'
  },
  'trough_exos500bf': {
    name: 'EXOS. 500 BF',
    type: 'price'
  },
  'trough_exos': {
    name: 'EXOS.',
    type: 'price'
  },
  'trough_exosbf': {
    name: 'EXOS. BF',
    type: 'price'
  },
  'trough_medcare': {
    name: 'MEDCARE'
  },
  'trough_medcarebf': {
    name: 'MEDCARE BF',
    type: 'price'
  },
  'trough_medcarebfs': {
    name: 'MEDCARE BF S',
    type: 'price'
  },
  'trough_exos_drain': {
    name: 'Strainer drain valve',
    description: 'always with selection EXOS. trough',
    type: 'price'
  },
  'trough_exos_cover': {
    name: 'Cover plate',
    description: 'always with selection EXOS. trough',
    type: 'price'
  },
  'trough_exos_antitheft': {
    name: 'Anti-theft device',
    description: 'always with selection EXOS. trough',
    type: 'price'
  },
  'trough_variusmed_mzb_standpipe': {
    name: 'Standpipe valve with valve body',
    description: 'always with VARIUSmed MZB',
    type: 'price'
  },
  'trough_overflow': {
    name: 'Overflow system incl. hole',
    description: 'always with selection trough with overflow',
    type: 'price'
  },
  'color_alpine': {
    name: 'Alpine white factor',
    type: 'percentage'
  },
  'color_granite': {
    name: 'Granite shades factor (gloss, matt)',
    description: 'additional costs on: plate, trough, apron, surge edge, splashback, topcoat',
    type: 'percentage'
  },
  'mounting_console_450_stainlessSteel': {
    name: 'Console 450 mm, stainless steel (incl. fixing material + end caps)',
    type: 'price'
  },
  'mounting_console_450_stainlessSteelWhite': {
    name: 'Console 450 mm, white (incl. fixing material + end caps)',
    type: 'price'
  },
  'mounting_console_370_stainlessSteel': {
    name: 'Console 370 mm, stainless steel (incl. fixing material + end caps)',
    type: 'price'
  },
  'mounting_console_370_stainlessSteelWhite': {
    name: 'Console 370 mm, white (incl. fixing material + end caps)',
    type: 'price'
  },
  'mounting_angle_stainlessSteel': {
    name: 'Angle bar 380 mm complete, 2000105048 (incl. fixing material)',
    type: 'price'
  },
  'mounting_angle_stainlessSteelWhite': {
    name: 'Angle bar 380 mm complete, white, 2030051364 (incl. fixing material)',
    type: 'price'
  },
  'mounting_safetycatch_stainlessSteel': {
    name: 'Trigger safety set (2 pieces) 2000105062 (incl. fixing material)',
    type: 'price'
  },
  'mounting_safetycatch_stainlessSteelWhite': {
    name: 'Trigger safety set, white (2 pieces), 2030051369 (incl. fixing material)',
    type: 'price'
  },
  'mounting_miranit_straight': {
    name: 'MIRANIT console, straight (incl. fixing material)',
    type: 'price'
  },
  'mounting_miranit_diagonal': {
    name: 'MIRANIT console, diagonal (incl. fixing material)',
    type: 'price'
  },
  'mounting_fixing': {
    name: 'Fixing material (for preshaped backwall), per trough',
    type: 'price'
  },
  'packaging_upto_1000': {
    name: 'Up to 1 m',
    description: 'Price valid up to 1000 mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'packaging_upto_2000': {
    name: 'Up to 2 m',
    description: 'Price valid up to 1000 mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'packaging_upto_3000': {
    name: 'Up to 3 m',
    description: 'Price valid up to 1000 mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'packaging_upto_999999': {
    name: 'From 3 m',
    description: 'Price valid up to 1000 mm, thereafter calculated on width of washbasin',
    type: 'price'
  },
  'pallet_upto_800': {
    name: '800 mm (m. S. 3-4, o. S. X.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_1200': {
    name: '1200 mm (m. S. 5-6, o. S. 5.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_1400': {
    name: '1400 mm (m. S. 5, o. S. 5.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_1600': {
    name: '1600 mm (m. S. 5, o. S. 5.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_1750': {
    name: '1750 mm (m. S. 5, o. S. 5.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_2000': {
    name: '2000 mm (m. S. 4, o. S. 4.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_2300': {
    name: '2300 mm (m. S. 4, o. S. 4.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_2500': {
    name: '2500 mm (m. S. 4, o. S. 4.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_2700': {
    name: '2700 mm (m. S. 4, o. S. 4.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_3000': {
    name: '3000 mm (m. S. 2-3, o. S. 2.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_3500': {
    name: '3500 mm (m. S. 2, o. S. 2.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  'pallet_upto_999999': {
    name: '4000 mm (m. S. 2, o. S. 2.)',
    description: 'Pallet min. 100 mm larger than washbasin',
    type: 'price'
  },
  // 'delivery': {
  //     name: 'Delivery fee if outside of Germany'
  // },
  'completion': {
    name: 'Per washbasin',
    type: 'price'
  }
};
exports.marketDetails = {
  'country': {
    name: 'Country',
    type: 'select',
    options: 'countries',
    required: true
  },
  'labor': {
    name: 'Labor',
    type: 'select',
    options: ['101', '391']
  },
  'condition_type': {
    name: 'Condition Type',
    default: 'PPR0',
    disabled: true,
    type: 'string'
  },
  'distribution_channel': {
    name: 'Distribution Channel',
    default: '10',
    disabled: true,
    type: 'string'
  },
  'division': {
    name: 'Division',
    default: '00',
    disabled: true,
    type: 'string'
  },
  'sales_org': {
    name: 'Plant / Sales Org',
    type: 'select',
    options: ['1010', '3910'],
    required: true
  },
  'sales_office': {
    name: 'Sales Office',
    type: 'select',
    options: ['1010', '1030', '1040', '3910', '3911', '3912', '3913', '3914', '3915'],
    required: true
  },
  'price_list': {
    name: 'Price List',
    type: 'select',
    options: ['AT', 'BE', 'CH', 'CZ', 'DE', 'E2', 'E3', 'EE', 'ES', 'FR', 'IT', 'NE'],
    required: true
  },
  'currency': {
    name: 'Currency',
    type: 'select',
    options: 'currencies',
    required: true
  },
  'cbna': {
    name: 'CBNA / NORM',
    type: 'select',
    options: ['CBNA', 'NORM']
  },
  'material_pricing_group': {
    name: 'Material Pricing Group',
    type: 'select',
    options: ['A1', 'A2', 'D2']
  },
  'volume_rebate_group': {
    name: 'Volume Rebate Group',
    type: 'select',
    options: ['D1', 'D4']
  },
  'freight_factor': {
    name: 'Freight surcharge',
    type: 'percentage',
    required: true
  },
  'sales_factor': {
    name: 'Sale factor',
    type: 'percentage',
    required: true
  },
  'exchange_rate': {
    name: 'Exchange rate from EUR',
    type: 'price',
    required: true
  },
  'vat': {
    name: 'VAT',
    type: 'percentage',
    required: true
  },
  // 'special_packaging': {
  //     name: 'Special Packaging',
  //     type: 'checkbox'
  // },
  'special_packaging_price': {
    name: 'Special Packaging Price',
    type: 'price'
  }
};

exports.getPartDetail = function (part, detail, lang, includeBrTags, partType) {
  if (includeBrTags === void 0) {
    includeBrTags = false;
  }

  if (partType === void 0) {
    partType = 'accessories';
  }

  var partDetails = partType === 'accessories' ? exports.accessoryPartDetails : partType === 'washbasin' ? exports.washbasinPartDetails : exports.marketDetails; // part = part.toLocaleLowerCase();

  var value;

  if (partDetails[part] && partDetails[part][detail]) {
    value = partDetails[part][detail]; // Translate... 

    if (value === 'PartTranslation') {
      value = utils_1.formatMessage(lang, value + "." + part + "." + detail);
    }
  }

  if (value && value.split && includeBrTags) {
    value = value.split('\n').join('<br/><br/>');
  }

  return value;
};